"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchSubBusiness = exports.useFetchOutletsForFranchise = exports.useFetchOutletsForOwner = exports.useUpdateOutlet = exports.useCreateOutlet = exports.useFetchOutlet = void 0;
const react_redux_1 = require("react-redux");
const outletAction_1 = require("./outletAction");
const react_router_dom_1 = require("react-router-dom");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
function useFetchOutlet() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const outletFetchLoading = (0, react_redux_1.useSelector)((state) => state['outlet/fetch'].loading);
    const outletFetchData = (0, react_redux_1.useSelector)((state) => state['outlet/fetch'].data);
    const outletFetchError = (0, react_redux_1.useSelector)((state) => state['outlet/fetch'].error);
    const outletFetch = (payload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, outletAction_1.fetch)(payload));
    });
    return { outletFetch, outletFetchLoading, outletFetchData, outletFetchError };
}
exports.useFetchOutlet = useFetchOutlet;
function useCreateOutlet() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const outletCreateLoading = (0, react_redux_1.useSelector)((state) => state['outlet/create'].loading);
    const outletCreateData = (0, react_redux_1.useSelector)((state) => state['outlet/create'].data);
    const outletCreateError = (0, react_redux_1.useSelector)((state) => state['outlet/create'].error);
    const outletCreate = (payload, onComplete) => __awaiter(this, void 0, void 0, function* () {
        try {
            let result = yield (0, AuthGuard_1.isLoggedIn)();
            if (!result) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, outletAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Error updating outlet');
            }
        }
        catch (err) {
            onComplete(false, true, err.message);
        }
    });
    return {
        outletCreate,
        outletCreateLoading,
        outletCreateData,
        outletCreateError
    };
}
exports.useCreateOutlet = useCreateOutlet;
function useUpdateOutlet() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const outletUpdateLoading = (0, react_redux_1.useSelector)((state) => state['outlet/update'].loading);
    const outletUpdateData = (0, react_redux_1.useSelector)((state) => state['outlet/update'].data);
    const outletUpdateError = (0, react_redux_1.useSelector)((state) => state['outlet/update'].error);
    const outletUpdate = (payload, onComplete) => __awaiter(this, void 0, void 0, function* () {
        try {
            let result = yield (0, AuthGuard_1.isLoggedIn)();
            if (!result) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, outletAction_1.update)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Error updating outlet');
            }
        }
        catch (err) {
            onComplete(false, true, err.message);
        }
    });
    return {
        outletUpdate,
        outletUpdateLoading,
        outletUpdateData,
        outletUpdateError
    };
}
exports.useUpdateOutlet = useUpdateOutlet;
function useFetchOutletsForOwner() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const outletFetchLoading = (0, react_redux_1.useSelector)((state) => state['outlet/fetchOutletsForOwner'].loading);
    const outletFetchData = (0, react_redux_1.useSelector)((state) => state['outlet/fetchOutletsForOwner'].data);
    const outletFetchError = (0, react_redux_1.useSelector)((state) => state['outlet/fetchOutletsForOwner'].error);
    const outletFetch = (payload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, outletAction_1.fetchOutletsForOwner)(payload));
    });
    return { outletFetch, outletFetchLoading, outletFetchData, outletFetchError };
}
exports.useFetchOutletsForOwner = useFetchOutletsForOwner;
function useFetchOutletsForFranchise() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const outletFetchLoading = (0, react_redux_1.useSelector)((state) => state['outlet/fetchOutletsForFranchise'].loading);
    const outletFetchData = (0, react_redux_1.useSelector)((state) => state['outlet/fetchOutletsForFranchise'].data);
    const outletFetchError = (0, react_redux_1.useSelector)((state) => state['outlet/fetchOutletsForFranchise'].error);
    const outletFetch = (payload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, outletAction_1.fetchOutletsForFranchise)(payload));
    });
    return { outletFetch, outletFetchLoading, outletFetchData, outletFetchError };
}
exports.useFetchOutletsForFranchise = useFetchOutletsForFranchise;
function useFetchSubBusiness() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const loading = (0, react_redux_1.useSelector)((state) => state['outlet/fetchSubBusiness'].loading);
    const data = (0, react_redux_1.useSelector)((state) => state['outlet/fetchSubBusiness'].data);
    const error = (0, react_redux_1.useSelector)((state) => state['outlet/fetchSubBusiness'].error);
    const fetch = () => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, outletAction_1.fetchSubBusiness)());
    });
    return { fetch, loading, data, error };
}
exports.useFetchSubBusiness = useFetchSubBusiness;
